import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { cancelReservation, CancelReservationPayload, reservationCanceled, reservationCancelFailed } from '../../actions/reservation/cancelReservation';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* cancelReservationSaga({ payload }: Action<CancelReservationPayload>) {
  const { reservationUuid } = payload;
  const token = yield getAuthenticationToken();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.cancelReservation, token, {
    reservationUuid,
  });
  const { error } = response;
  const timestamp = moment();
  if (!error) {
    yield put(reservationCanceled({ reservationUuid, timestamp }));
  } else {
    yield put(reservationCancelFailed({ reservationUuid, timestamp }));
  }
}

export default function* watchCancelReservationSaga() {
  yield takeEvery(cancelReservation, cancelReservationSaga);
}
